export default "__VITE_ASSET__Bx23Gz96__"